import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import DayJsUtils from '@date-io/dayjs';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker as MuiDatePicker,
} from '@material-ui/pickers';

const DatePicker = ({
  onChange,
  value,
  label,
  className,
  minDate,
  required,
}) => {
  const handleChange = value => {
    const modifiedDate = dayjs(value).format('YYYY-MM-DD');
    onChange(modifiedDate);
  };

  return (
    <MuiPickersUtilsProvider utils={DayJsUtils}>
      <MuiDatePicker
        autoOk={true}
        className={className}
        minDate={minDate}
        disabled={minDate === null}
        required={required}
        variant="inline"
        format="DD-MM-YYYY"
        id={label}
        label={label}
        value={value ? value : null}
        InputAdornmentProps={{ position: 'start' }}
        onChange={handleChange}
      />
    </MuiPickersUtilsProvider>
  );
};

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Date),
  label: PropTypes.string,
  className: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  required: PropTypes.bool,
};

export default DatePicker;
